import functions from '../functions';
import pagination from '../components/pagination';
import listResults from '../components/listResults';

$(() => {
    list.init();
})

const list = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {},
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: null,
        sortBy: null, 
        objectName: null, 
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'persons', 'personsInObject', 'sortBy', '_page'],
    init() {

        this.$form = $('.search-form');
        this.form = this.$form[0];

        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];  

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;

        if(! this.form) {
            return;
        }

        $('[name="destination"]').on('change', e => {
            const $target = $(e.currentTarget);
            const $msClear = $target.siblings('.ms-clear');
            const value = $target.val();
            
            value && $msClear.removeClass('d-none');
            ! value && $msClear.addClass('d-none');
        });

    },
    getParams(params, defaults = {}, filterParams = {}) {
        params = $.extend({}, defaults, filterParams, functions.getUrlData(true));
        this.splitCalendarDates(params.dates);
        this.setDestination(params.destination);

        return params;
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    setDestination(destination) {

        if(destination) {
            const destinations = destination.split(',');

            let countryIds = [],
                regionIds = [],
                rivieraIds = [],
                placeIds = [];

            destinations.forEach(destination => {
                const dest = destination.split(':');
                
                this.params.countryId = dest[0] ? this.getDestinationIds(dest[0], countryIds) : this.defaults.countryId;
                this.params.regionId = dest[1] ? this.getDestinationIds(dest[1], regionIds) : null;
                this.params.rivieraId = dest[2] ? this.getDestinationIds(dest[2], rivieraIds) : null;
                this.params.placeId = dest[3] ? this.getDestinationIds(dest[3], placeIds) : null;
            });
        } else {
            this.params.countryId = this.defaults.countryId;
            this.params.regionId = null;
            this.params.rivieraId = null;
            this.params.placeId = null;
        }
    },
    getDestinationIds(destination, array) {
        if(destination && $.inArray(destination, array)) {
            array.push(destination);
        }
        return array.join();
    },
    find(params) {
        
        this.setLoadingMode();
        this.params = params;

        return $.get('/services/list/', params);

    },
    findDone(response) {
        response = JSON.parse(response);          

        this.unsetLoadingMode();

        this.total = response.total;

        this.$listItems.html(response.html);
        if (this.total != 0) {

            if($('.paginate')[0]) {
                $('.paginate').html(pagination({
                    currentPage: this.params._page,
                    total: this.total,
                    perPage: this.params.perPage,
                }));
            }
        }

        listResults.getResults(this.total, this.params._page, this.params.perPage);

    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true);
    },
    setLoadingMode() {
        if(! this.loading) {
            this.loading = true;

            // form submit btn
            (this.$form).find('button').prop('disabled', true);

            if ( ! $('.spinner').length) {
                $('<div class="spinner d-none"><div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div></div>').insertBefore('.list-items');
                // <span class="sr-only">Loading...</span>
            }

            $('.spinner').removeClass('d-none');
            $('.spinner').addClass('d-flex justify-content-center');
            this.$listItems.addClass('d-none');
            $('.paginate').addClass('d-none');
        }
    },
    unsetLoadingMode() {
        if(this.loading) {
            this.loading = false;

            // form submit btn
            (this.$form).find('button').prop('disabled', false);

            $('.spinner').removeClass('d-flex justify-content-center');
            $('.spinner').addClass('d-none');
            this.$listItems.removeClass('d-none');
            $('.paginate').removeClass('d-none');

            //functions.scrollToElement(this.$listItems, 100);
        }
    },
    setBtnSearchValue(params) {
        const $btnSearchModal = $('.btn-search-modal .btn-value');
        let btnSearchModalValue = ``;

        const months = [
            'Januar',
            'Februar',
            'Mart',
            'April',
            'Maj',
            'Jun',
            'Jul',
            'Avgust',
            'Septembar',
            'Oktobar',
            'Novembar',
            'Decembar',
        ];
        
        setTimeout(() => {

            if (params.departurePoint) {
                const departurePoint = $('.search-packages .select2-selection__rendered').text();
                btnSearchModalValue += `<div class="departure-value">${ departurePoint }</div>`;
            }

            if (params.destination) {
                const destination = $('.form-guide').text();

                btnSearchModalValue += `<span class="destination-value">${ destination }</span>`;
            }

            
            if (params.dateFrom && params.dateTo) {
                const dateFrom = new Date(params.dateFrom);
                const dateTo = new Date(params.dateTo);

                const dateFromMonth = dateFrom.getMonth();
                const dateToMonth = dateTo.getMonth();
                btnSearchModalValue += params.destination ? ` ` : ``;

                if (dateFromMonth == dateTo.getMonth()) {
                    btnSearchModalValue += `<span class="dates-value">${ months[dateFromMonth] } ${ dateFrom.getDate() }-${ dateTo.getDate() }</span>`;
                } else {
                    btnSearchModalValue += `<span class="dates-value">${ months[dateFromMonth] } ${ dateFrom.getDate() } - ${ months[dateToMonth] } ${ dateTo.getDate() }</span>`
                }
            }

            if (params.guests) {
                let aGuests = params.guests.split(',');
                let guestTotal = 0;
                aGuests.forEach(elem => {
                    guestTotal += +elem;
                });

                if (guestTotal) {
                    if (params.destination || (params.dateFrom && params.dateTo)) {
                        btnSearchModalValue += `, `;
                    }

                    btnSearchModalValue += `<span class="guests-value">${ guestTotal } ${ guestTotal > 1 ? 'osobe' : 'osoba' }</span>`;
                }
            }

            btnSearchModalValue = btnSearchModalValue || $btnSearchModal.attr('data-placeholder');
            $btnSearchModal.html(btnSearchModalValue);
        }, 800);

    }
};

export {
    list,
};
